import z from 'zod';
import { PERMISSIONS } from '@shared/constants/permissionService.constant';

const permissionsSchema = z.array(z.enum(PERMISSIONS));

export { permissionsSchema };
